<template>
<el-footer>
	<div class="footer">
		<div class="mod_help">
			<div style="width: 340px;">
				<i class="el-icon-phone-outline" style="font-size: 40px;margin-right: 10px;"></i>{{ footer.name }}
				<div style="margin-top: 8px;font-size: 20px;font-weight: 600">{{ footer.title }}</div>
			</div>
			<div style="font-size: 12px">
				<p>
					<span href="" target="_blank">
						&copy; 国家航天局对地观测与数据中心 </span>
					<span class="margin10">|</span>
					<router-link to="/aboutUS?type=jj">联系我们</router-link>
					<span class="margin10">|</span>
					<router-link to="/aboutUS?type=sysmhmztk">使用条款和免责声明</router-link>
					<span class="margin10">|</span>
					<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备20003293号-4</a>
					<span class="margin10">|</span>
					<span style="position: relative"><span class="icon"></span><a
						href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank"
						style="padding-left: 22px;">京ICP备20003293号</a></span>
				</p>
				<p class="coty">地址：<span>{{ address.title || "北京市朝阳区大屯路中科院遥感地球所五层"
				}}</span>&nbsp;&nbsp;&nbsp;&nbsp;邮编：<span>{{ youbian.title || 100101 }}</span>
				</p>
			</div>
			<div style="display: flex">
				<div style="">
					<div style="width: 70px;height: 70px;display: inline-block">
						<img src="https://www.cpeos.org.cn/img/gfapp.png" alt="" style="width: 100%">
					</div>
					<div style="font-size: 12px">扫描下载 app</div>
				</div>
				<div></div>
				<div style="width: 170px;">
					<div style="width: 70px;height: 70px;display: inline-block">
						<img src="~@/assets/image/gfgcgzh.png" alt="" style="width: 100%">
					</div>
					<div style="font-size: 12px"> 欢迎关注公众号</div>
				</div>
			</div>
		</div>
	</div>
</el-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	components: {},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			footer: 'getFooterConfig',
			address: 'getAddress',
			youbian: 'getYB'
		})
	},
	methods: {},
};
</script>

<style scoped>
.footer {
	width: 100%;
	text-align: center;
	background: #2f2f2f;
	padding-bottom: 20px;
	padding-left: 40px;
	padding-right: 40px;
}

.footer .ng-promise-box {
	border-bottom: 1px solid #3d3d3d;
	line-height: 145px;
}

.footer .ng-promise-box {
	margin: 0 auto;
	border-bottom: 1px solid #3d3d3d;
	line-height: 145px;
}

.footer .ng-promise-box .ng-promise p a {
	color: #fff;
	font-size: 20px;
	margin-right: 210px;
	padding-left: 44px;
	height: 40px;
	display: inline-block;
	line-height: 40px;
	text-decoration: none;
	background: url("../assets/imgs/us-icon.png") no-repeat left 0;
}

.footer .github {
	height: 50px;
	line-height: 50px;
	margin-top: 20px;
}


.footer .mod_help {
	/*text-align: center;*/
	color: #888888;
	padding-top: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.footer .mod_help p {
	height: 20px;
	margin: 20px 0 16px 0;
}

.footer .mod_help p a {
	color: #888888;
	text-decoration: none;
}

.footer .mod_help p a:hover {
	color: #fff;
}

.footer .mod_help p span {
	/*padding: 0 10px;*/
}

.margin10 {
	margin: 0 10px;
}

.icon {
	display: inline-block;
	width: 19px;
	height: 19px;
	background: url("~@/assets/image/hz_icon.png") no-repeat;
	background-position-x: -42px;
	position: absolute;
}
</style>